(() => {
  const pricePerGram = { pla: 3, petg: 4, tpu: 5 };
  const VAT_RATE = 0.25;          // 25% moms
  const RANGE_PCT = 0.15;         // ±15% intervall

  const setupFee = 25;            // startavgift (ändra fritt)
  const minPrice = 99;            // minpris per order (ändra fritt)

  const formatSEK = (n) =>
    new Intl.NumberFormat('sv-SE', {
      style: 'currency',
      currency: 'SEK',
      maximumFractionDigits: 0
    }).format(n);

  const clampInt = (val, fallback, min, max) => {
    const n = Math.round(Number(val));
    if (!Number.isFinite(n)) return fallback;
    return Math.min(max, Math.max(min, n));
  };

  const getEl = (id) => document.getElementById(id);

  function getDiscountRate(qty) {
    if (qty >= 10) return 0.10;
    if (qty >= 5) return 0.05;
    return 0;
  }

  function buildMailto(state) {
    const subject = `Offertförfrågan 3D-print – ${state.materialLabel}, ${state.qty} st`;

    const lines = [
      `Hej!`,
      ``,
      `Jag vill gärna ha en exakt offert på en 3D-print.`,
      ``,
      `Val i kalkylator:`,
      `- Material: ${state.materialLabel}`,
      `- Vikt per del: ${state.weight} g`,
      `- Antal: ${state.qty} st`,
      `- Komplexitet: ${state.complexityLabel}`,
      `- Tillägg: ${state.addonsLabel || 'Inga'}`
    ];

    if (state.fileUrl) {
      lines.push(``);
      lines.push(`Fil-länk: ${state.fileUrl}`);
    }

    lines.push(
      ``,
      `Prisuppskattning (exkl moms): ${state.rangeExVatText}`,
      `Prisuppskattning (inkl moms): ${state.rangeIncVatText}`,
      `Exkl. frakt.`,
      ``,
      `Hälsningar`
    );

    const body = lines.join('\n');
    return `mailto:info@friluftstyger.se?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  function calc() {
    const material = getEl('material')?.value || 'pla';
    const weight = clampInt(getEl('weight')?.value, 0, 0, 200000);
    const qty = clampInt(getEl('qty')?.value, 1, 1, 200);
    const complexityAdd = Number(getEl('complexity')?.value || 0);

    const expressAdd = getEl('express')?.checked ? 100 : 0;
    const colorAdd = getEl('color')?.checked ? 25 : 0;

    const ppg = pricePerGram[material] ?? 3;
    const materialCostPerItem = Math.max(0, weight) * ppg;
    const complexityPerItem = Math.max(0, complexityAdd);

    const itemsSubtotal = (materialCostPerItem + complexityPerItem) * qty;
    const discountRate = getDiscountRate(qty);
    const discountAmount = Math.round(itemsSubtotal * discountRate);

    const addons = expressAdd + colorAdd;

    let rawTotalExVat = setupFee + (itemsSubtotal - discountAmount) + addons;
    rawTotalExVat = Math.round(rawTotalExVat);

    const totalExVat = Math.max(minPrice, rawTotalExVat);

    const lowExVat = Math.round(totalExVat * (1 - RANGE_PCT));
    const highExVat = Math.round(totalExVat * (1 + RANGE_PCT));
    const lowIncVat = Math.round(lowExVat * (1 + VAT_RATE));
    const highIncVat = Math.round(highExVat * (1 + VAT_RATE));

    const result = getEl('result');
    const price = getEl('price');
    const priceVat = getEl('priceVat');
    const breakdown = getEl('breakdown');
    const emailBtn = getEl('emailBtn');

    if (!result || !price || !priceVat || !breakdown || !emailBtn) return;

    if (weight <= 0) {
      result.style.display = 'block';
      price.textContent = '—';
      priceVat.textContent = '';
      breakdown.textContent = 'Ange en vikt större än 0 gram.';
      emailBtn.style.display = 'none';
      return;
    }

    const rangeExVatText = `${formatSEK(lowExVat)} – ${formatSEK(highExVat)} (exkl. moms)`;
    const rangeIncVatText = `${formatSEK(lowIncVat)} – ${formatSEK(highIncVat)} (inkl. moms)`;

    price.textContent = rangeExVatText;
    priceVat.textContent = rangeIncVatText;

    const materialLabel =
      material === 'pla' ? 'PLA' :
      material === 'petg' ? 'PETG' :
      material === 'tpu' ? 'TPU' : material.toUpperCase();

    const complexityLabel =
      String(complexityAdd) === '0' ? 'Enkel (0 kr)' :
      String(complexityAdd) === '25' ? 'Medel (+25 kr)' :
      String(complexityAdd) === '75' ? 'Hög (+75 kr)' : `+${complexityAdd} kr`;

    const addonsLabel = [
      expressAdd ? 'Express' : '',
      colorAdd ? 'Specialfärg' : ''
    ].filter(Boolean).join(', ');

    const lines = [
      `Antal: ${qty} st`,
      `Material: ${formatSEK(materialCostPerItem)} per del (${ppg} kr/g × ${weight} g)`,
      `Komplexitet: ${formatSEK(complexityPerItem)} per del`,
      `Startavgift: ${formatSEK(setupFee)}`,
      addons ? `Tillägg (per order): ${formatSEK(addons)}` : `Tillägg (per order): ${formatSEK(0)}`,
      discountRate ? `Mängdrabatt: −${formatSEK(discountAmount)} (${Math.round(discountRate * 100)}%)` : '',
      rawTotalExVat < minPrice ? `Minimipris tillämpat: ${formatSEK(minPrice)}` : ''
    ].filter(Boolean);

    breakdown.innerHTML = lines.join('<br>');

    const mailState = {
      materialLabel,
      weight,
      qty,
      complexityLabel,
      addonsLabel,
      rangeExVatText,
      rangeIncVatText,
      fileUrl: null
    };

    emailBtn.style.display = 'block';

    emailBtn.onclick = async () => {
      // 1) Försök plocka URL från det synliga länkelementet
      const linkEl = document.getElementById('fileUrl');
      const href = linkEl?.getAttribute('href');
      if (href && href !== '#') {
        mailState.fileUrl = href;
        window.location.href = buildMailto(mailState);
        return;
      }

      // 2) Om uploadcare-widget finns: vänta in filen om den håller på att laddas
      try {
        const widget = window.uploadcare ? uploadcare.Widget('#modelFile') : null;
        if (widget) {
          const filePromise = widget.value();
          if (filePromise) {
            emailBtn.disabled = true;
            const oldText = emailBtn.textContent;
            emailBtn.textContent = 'Förbereder mail...';

            const fileInfo = await filePromise;
            const url = fileInfo && fileInfo.cdnUrl ? fileInfo.cdnUrl : null;
            mailState.fileUrl = url;

            emailBtn.disabled = false;
            emailBtn.textContent = oldText;

            window.location.href = buildMailto(mailState);
            return;
          }
        }
      } catch (e) {
        // Faller tillbaka utan fil-länk
      }

      window.location.href = buildMailto(mailState);
    };

    result.style.display = 'block';
    result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function bind() {
    const btn = getEl('calcBtn');
    if (btn) btn.addEventListener('click', calc);

    ['material','weight','qty','complexity','express','color'].forEach((id) => {
      const el = getEl(id);
      if (!el) return;
      el.addEventListener('change', calc);
      if (id === 'weight' || id === 'qty') {
        el.addEventListener('input', () => {
          clearTimeout(window.__print3dDebounce);
          window.__print3dDebounce = setTimeout(calc, 150);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();